export type MTPrepareTab = {
  label: string
  screenName: string
  status: string
  children?: { label: string; screenName: string; status: string; id: number }[]
}

/** Fixed 5-bucket structure — identical for all territories (AC2, AC6: Processed is default at index 1) */
export const MT_PREPARE_TABS: MTPrepareTab[] = [
  { label: 'Unprocessed', screenName: 'UNPROCESSED', status: 'unprocessed' },
  { label: 'Processed', screenName: 'PROCESSED', status: 'processed' },
  { label: 'Exceptions', screenName: 'EXCEPTIONS', status: 'exceptions' },
  { label: 'Excluded', screenName: 'EXCLUDED', status: 'excluded' },
  // {
  //   label: 'Negative Entries',
  //   screenName: 'NEGATIVE',
  //   status: 'negative',
  //   children: [
  //     { label: 'Unmapped', screenName: 'UNMAPPED', status: 'unmapped', id: 1 },
  //     { label: 'Mapped', screenName: 'MAPPED', status: 'mapped', id: 2 },
  //   ],
  // },
]

/** Default tab index — Processed (AC6) */
export const MT_PREPARE_DEFAULT_TAB = 1

export const MT_PREPARE_ACTIONS = {
  EXCLUDE: 'EXCLUDED',
  INCLUDE: 'INCLUDED',
}

/** Toolbar visibility matrix per bucket (AC10) */
export const MT_PREPARE_TOOLBAR_CONFIG: Record<
  string,
  {
    fullScreen: boolean
    columnConfig: boolean
    download: boolean
    search: boolean
    edit: boolean
    excludeInclude: boolean
    suggestWHTRate: boolean
    reprocess: boolean
    includeSwitch: boolean
  }
> = {
  UNPROCESSED: {
    fullScreen: true,
    columnConfig: true,
    download: true,
    search: true,
    edit: false,
    excludeInclude: false,
    suggestWHTRate: false,
    reprocess: false,
    includeSwitch: false,
  },
  PROCESSED: {
    fullScreen: true,
    columnConfig: true,
    download: true,
    search: true,
    edit: true,
    excludeInclude: true,
    suggestWHTRate: true,
    reprocess: true,
    includeSwitch: true,
  },
  EXCEPTIONS: {
    fullScreen: true,
    columnConfig: true,
    download: true,
    search: true,
    edit: true,
    excludeInclude: false,
    suggestWHTRate: false,
    reprocess: true,
    includeSwitch: false,
  },
  EXCLUDED: {
    fullScreen: true,
    columnConfig: true,
    download: true,
    search: true,
    edit: false,
    excludeInclude: true,
    suggestWHTRate: false,
    reprocess: false,
    includeSwitch: false,
  },
  NEGATIVE: {
    fullScreen: true,
    columnConfig: true,
    download: true,
    search: true,
    edit: false,
    excludeInclude: false,
    suggestWHTRate: false,
    reprocess: false,
    includeSwitch: false,
  },
}
